<div class="login-container">
  <mat-card class="login-card">

    <div *ngIf="!emailSent">
      <h3>Внесете ја вашата е-маил адреса</h3>
      <form [formGroup]="forgotpassword" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Е-маил адреса</mat-label>
          <input matInput formControlName="email"/>
          <mat-error *ngIf="forgotpassword.get('email')?.hasError('pattern')">
            Внесете валидна е-маил адреса
          </mat-error>
        </mat-form-field>
        <button mat-raised-button color="primary" class="login-button" type="submit"
                [disabled]="forgotpassword.invalid || isLoading">
          <span *ngIf="!isLoading">Потврди</span>
          <span *ngIf="isLoading">Испраќање...</span>
        </button>
      </form>
      <div class="forgot-password">
        <a (click)="goToLogin()">Назад кон најава</a>
      </div>
    </div>

    <div *ngIf="emailSent" class="email-sent">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h3>Е-маилот е испратен!</h3>
      <p>Проверете ја вашата е-маил адреса за линкот за ресетирање на лозинката.</p>
      <p class="hint">Линкот е валиден 15 минути.</p>
      <button mat-raised-button color="primary" class="login-button" (click)="goToLogin()">
        Назад кон најава
      </button>
    </div>

  </mat-card>
</div>